<script lang="ts">
    import Fa from 'svelte-fa'
    import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
    import { each, onMount } from 'svelte/internal'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import { ReferralsRepository } from '../../modules/toolsApi/referrals/referrals.repository'
    import { ReferralsService } from '../../modules/toolsApi/referrals/referrals.service'
    import { Referral } from '../../modules/toolsApi/referrals/referral'
    import type { CreateReferralDto } from '../../modules/toolsApi/referrals/dto/create-referral.dto'
    import { Store } from '../../modules/infra/store.service'
    import type { CreateReferralItemDto } from '../../modules/toolsApi/referrals/dto/create-referral-item.dto'
    import { PersonsRepository } from '../../modules/eventsApi/persons/persons.repository'
    import { PersonsService } from '../../modules/eventsApi/persons/persons.service'
    import { Person } from '../../modules/eventsApi/persons/person'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import ReferralEntriesItems from './referral-entries-items.svelte'
    import { ReferralItem } from '../../modules/toolsApi/referrals/referral-item'
    import DateSelect from '../_common/date-select.svelte'
    import ApexCharts from 'apexcharts'
    import dayjs from 'dayjs'
    import Zact from '../_common/z/zact.svelte'

    const entityRep = new ReferralsRepository()
    const entityS = new ReferralsService(entityRep)

    let personsR = new PersonsRepository()
    let personsS = new PersonsService(personsR)
    let isCustomer = []

    let min = 0
    let total = 0
    let show = false
    let step = 1
    let entities = []
    let entity: Referral = new Referral()

    let dates: { from: Date; to: Date } = window.api.utils.dates.currentMonth()
    let chartContainer
    let options = {}

    onMount(async () => {
        await loadEntities()
    })

    async function showReport(from, to) {
        let report: any[] = await entityS.report(from, to)
        options = {
            series: [
                {
                    name: 'Novos',
                    data: chartDetail ? report.map((el) => el.included) : [report.map((el) => el.included).reduce((total, el) => (total += el), 0)],
                },
                {
                    name: 'Contactados',
                    data: chartDetail ? report.map((el) => el.contacted) : [report.map((el) => el.contacted).reduce((total, el) => (total += el), 0)],
                },
                {
                    name: 'Agendados',
                    data: chartDetail ? report.map((el) => el.scheduled) : [report.map((el) => el.scheduled).reduce((total, el) => (total += el), 0)],
                },
                {
                    name: 'Compareceu',
                    data: chartDetail ? report.map((el) => el.attended) : [report.map((el) => el.attended).reduce((total, el) => (total += el), 0)],
                },
                {
                    name: 'Convertidos',
                    data: chartDetail ? report.map((el) => el.converted) : [report.map((el) => el.converted).reduce((total, el) => (total += el), 0)],
                },
            ],
            theme: {
                mode: 'light',
            },
            chart: {
                type: 'bar',
                height: 200,
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded',
                },
            },
            grid: {
                show: false,
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent'],
            },
            xaxis: {
                categories: chartDetail ? report.map((el) => dayjs(el.date).format('DD/MM')) : [''],
            },
            yaxis: {
                title: {
                    text: 'pessoas',
                },
            },
            fill: {
                opacity: 1,
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + ' pessoas'
                    },
                },
            },
        }
        if (chart) chart.destroy()
        chart = new ApexCharts(chartContainer, options)
        chart.render()
    }
    let chart = null

    function totalChange() {
        while (entity.items.length != total) {
            if (entity.items.length > total) {
                entity.items.pop()
                continue
            }
            if (entity.items.length < total) {
                let s = new ReferralItem()
                s.person = new Person()
                entity.items.push(s)
            }
        }
        entity = entity
    }

    function dateChanged(event) {
        dates = event.detail
        loadEntities()
    }

    let totalRevenue = 0
    let totalIncluido = 0
    let totalContactado = 0
    let totalRetornou = 0
    let totalAgendou = 0
    let totalCompareceu = 0
    let totalConverteu = 0
    async function loadEntities() {
        try {
            show = true
            step = 1
            const dt = {
                from: dates?.from || undefined,
                to: dates?.to || undefined,
            }
            entities = await entityS.getAll(dt)
            totalRevenue = 0
            totalIncluido = 0
            totalContactado = 0
            totalRetornou = 0
            totalAgendou = 0
            totalCompareceu = 0
            totalConverteu = 0

            for (const ent of entities) {
                totalIncluido += ent.total
                totalContactado += ent.contacted
                totalRetornou += ent.replied
                totalAgendou += ent.scheduled
                totalCompareceu += ent.attended
                totalConverteu += ent.converted
                totalRevenue += ent.revenue
            }
            await loadPersons(entities)
            entities = entities
            showReport(dt.from, dt.to)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function loadPersons(items) {
        let persons: Person[] = []
        let personsId = []
        for (const item of items) {
            personsId.push(item.personId)
        }
        if (personsId.length > 0) persons = await personsS.getAll({ persons: personsId.join(',') })
        for (let item of items) {
            item.person = persons.find((el) => el.personId === item.personId)
        }
    }

    async function editEntity(id: string) {
        try {
            show = true
            isCustomer = []
            //entity = await entityS.getOne(id)
            entity = entities.filter((el) => el.referralId === id)[0]
            await loadPersons(entity.items)
            min = entity.items.length
            total = min
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        isCustomer = []
        entity = new Referral()
        min = 1
        total = 0
        step = 2
    }

    async function saveEntity() {
        upsertEntity()
    }

    async function upsertEntity() {
        try {
            if (show) return
            show = true
            isCustomer = []
            const store: Store = new Store()
            const dto: CreateReferralDto = {
                referralId: entity.referralId,
                personId: entity.person?.personId,
                userId: store.token.userId,
                items: entity.items,
                allowCustomer: entity.allowCustomer,
            }
            if (!validateDto(dto)) {
                show = false
                return
            }
            entity = await entityS.create(dto)
            if (!entity.allowCustomer)
                for (const item of entity.items) {
                    if (item.isCustomer) {
                        isCustomer.push({ name: item.person.name, phone: item.person.phone })
                    }
                }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function validateDto(dto: CreateReferralDto) {
        if (!dto.personId) {
            evaluateError('Informe quem está indicando')
            return false
        }
        if (dto.items.length === 0) {
            evaluateError('Você deve informar ao menos 1 pessoa indicada')
            return false
        }
        for (const item of dto.items) {
            if (!item.person.name?.trim() || !item.person.phone?.trim() || item.relationship === '') {
                evaluateError('Informe o nome, telefone e parentêsco de todos os indicados')
                return false
            }
            if (item.person.phone.length < 10) {
                evaluateError('Informe o telefone com DDD')
                return
            }
        }
        return true
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este item?')) {
            return
        }
        try {
            show = true
            await entityS.remove(entity.referralId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function showEntities() {
        step = 1
    }

    function evaluateError(error) {
        window.error(error)
    }

    let chartDetail = false
    function toggleChart() {
        showReport(dates.from, dates.to)
    }
</script>

{#if step === 1}
    <Content>
        <Zact>
            <DateSelect startFrom={dates.from} startTo={dates.to} on:change={dateChanged} />
            <div class="spacer h-mobile" />
            {#if window.store.token.permissions.referral.referral.write}
                <button class="btn btn-primary" on:click={newEntity}><Fa icon={faPlusCircle} /> Nova indicação</button>
            {/if}
        </Zact>
        <div class="config-box mt-2">
            <div class="form-check form-switch">
                <input class="form-check-input" bind:checked={chartDetail} on:change={toggleChart} type="checkbox" role="switch" id="npsOn" />
                <label class="form-check-label" for="npsOn">Detalhar por dia</label>
            </div>
            <div bind:this={chartContainer} />
        </div>

        {#if isCustomer.length > 0}
            <div class="alert alert-warning mt-2">
                <div>Nem todos os contatos foram adicionados pois alguns já são clientes ou foram cadastrados no passado:</div>
                {#each isCustomer as customer}
                    <div>{customer.name} / {customer.phone}</div>
                {/each}
            </div>
        {/if}
        <div class="grid-head">
            <div class="row">
                <div class="col-1">Data</div>
                <div class="col">Nome de quem indicou</div>
                <div class="col-md-1 text-end">Total</div>
                <div class="col-md-1 text-end">Contactado</div>
                <div class="col-md-1 text-end">Retornou</div>
                <div class="col-md-1 text-end">Agendou</div>
                <div class="col-md-1 text-end">Compareceu</div>
                <div class="col-md-1 text-end">Converteu</div>
                <div class="col-md-1 text-end">Valor</div>
                <div class="col-md-1" />
            </div>
        </div>
        <div class="grid-body">
            {#each entities as item}
                <div class="row line liner py-1">
                    <div class="col-1" title={dayjs(item.createdAt).format('DD/MM/YYYY HH:mm')}>
                        {dayjs(item.createdAt).format('DD/MM/YYYY')}
                    </div>
                    <div class="col">{item.person?.name}</div>
                    <div class="col-md-1 text-end">{item.total}</div>
                    <div class="col-md-1 text-end">{item.contacted > 0 ? item.contacted : '-'}</div>
                    <div class="col-md-1 text-end">{item.replied > 0 ? item.replied : '-'}</div>
                    <div class="col-md-1 text-end">{item.scheduled > 0 ? item.scheduled : '-'}</div>
                    <div class="col-md-1 text-end">{item.attended > 0 ? item.attended : '-'}</div>
                    <div class="col-md-1 text-end">{item.converted > 0 ? item.converted : '-'}</div>
                    <div class="col-md-1 text-end">{parseInt(item.revenue).toFixed(2)}</div>
                    <div class="col-md-1 text-end">
                        <button
                            class="btn btn-secondary btn-sm"
                            on:click={() => {
                                editEntity(item.referralId)
                            }}>Editar</button
                        >
                    </div>
                </div>
            {/each}
            <div class="row mb-5 pb-5">
                <div class="col text-end">Total</div>
                <div class="col-md-1 text-end">{totalIncluido}</div>
                <div class="col-md-1 text-end">{totalContactado}</div>
                <div class="col-md-1 text-end">{totalRetornou}</div>
                <div class="col-md-1 text-end">{totalAgendou}</div>
                <div class="col-md-1 text-end">{totalCompareceu}</div>
                <div class="col-md-1 text-end">{totalConverteu}</div>
                <div class="col-md-1 text-end">{window.api.utils.utils.toReal(totalRevenue)}</div>
                <div class="col-md-1" />
            </div>
        </div>
        <LoadSpinner {show} />
    </Content>
{/if}
{#if step === 2}
    <Content>
        <Zact>
            <button class="btn btn-secondary" on:click={showEntities}>Voltar</button>
            <div class="spacer" />
            {#if window.store.token.permissions.referral.referral.write}
                {#if entity.referralId}
                    <button class="btn btn-caution" on:click={removeEntity}>Excluir</button>
                {/if}
                <button class="btn btn-primary" on:click={saveEntity}>Salvar</button>
            {/if}
        </Zact>
        <div class="grid-form">
            <div class="row">
                <div class="col">
                    <ZentitySelect fonte="pessoa" label="Quem indicou" bind:value={entity.person} />
                </div>
                <div class="col-md-2">
                    <div class="input-group">
                        <label for="" class="input-group-text">Quantidade</label>
                        <select name="" id="" class="form-select" bind:value={total} on:change={totalChange}>
                            {#each Array(50) as _, i}
                                <option value={i + min}>{i + min}</option>
                            {/each}
                        </select>
                    </div>
                </div>
                <div
                    class="col-md-3 d-flex align-items-center"
                    title="Por padrão clientes não podem ser indicados por outros clientes. Ative esta opção para permitir."
                >
                    <div class="form-check form-switch">
                        <input class="form-check-input" bind:checked={entity.allowCustomer} type="checkbox" role="switch" id="allowCustomer" />
                        <label class="form-check-label" for="npsOn">Permitir clientes atuais</label>
                    </div>
                </div>
            </div>
            {#each entity.items as item}
                <ReferralEntriesItems bind:item />
            {/each}
        </div>
    </Content>
{/if}
